///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { GtthEventManager } from '../services/event-manager.service';
import { GtthPreloaderModalEvent } from '../shared/preloader-modal/preloader-modal-event';
import { ProjectService } from '../services/project/project.service';
import { ProjectDTO, ProjectFolderDTO, ProjectFolderEnum } from '../generated/shared-types.model';
import { isDefined } from '@siklu/sui-lib/utils';

@Injectable()
export class ProjectDragAndDropService {
    private project: ProjectDTO;
    private folderId: number;
    private movingInProcess = false;
    private readonly openFolderTimeout = 2000;
    private openFolderTimer: any;

    constructor(
        private readonly projectService: ProjectService,
        private readonly eventManager: GtthEventManager
    ) {}

    public dragStart(project: ProjectDTO) {
        if (project.bugReport) {
            return;
        }
        this.project = project;
    }

    public drugOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    public drop(folder: ProjectFolderDTO) {
        this.clearOpenFolderTimer();

        const { id, parentId, type } = folder;

        if (!this.project || (!parentId && type === ProjectFolderEnum.BUG_REPORT)) {
            return;
        }

        if (this.movingInProcess || !isDefined(id) || id === this.project.parentId) {
            return;
        }

        this.movingInProcess = true;

        this.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Move Project')
        });

        this.project.parentId = id;
        this.projectService.update(this.project).subscribe(() => {
            this.project = undefined;
            this.movingInProcess = false;
            this.eventManager.broadcast({ name: 'projectModified', content: 'OK' });
            this.eventManager.broadcast({
                name: 'togglePreloaderModal',
                eventObject: GtthPreloaderModalEvent.hide()
            });
        });
    }

    public setOpenFolderTimer(folderId: number, callbackFunction) {
        if (isDefined(folderId) && this.folderId !== folderId) {
            this.clearOpenFolderTimer();
            this.folderId = folderId;
            this.openFolderTimer = setTimeout(() => {
                if (typeof callbackFunction === 'function') {
                    callbackFunction();
                }
                this.clearOpenFolderTimer();
            }, this.openFolderTimeout);
        } else if (!isDefined(folderId) && !!this.openFolderTimer) {
            this.clearOpenFolderTimer();
        }
    }

    public clearOpenFolderTimer() {
        if (this.openFolderTimer) {
            this.folderId = undefined;
            clearTimeout(this.openFolderTimer);
            this.openFolderTimer = undefined;
        }
    }
}
